import { useState } from "react";
import { HelpCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { PAGE_HELP } from "./content";
import { HelpDialog } from "./PageHelp";
import { helpPageForPath } from "./routeHelp";

/**
 * The one help trigger, top right of every page.
 *
 * It resolves the page from the URL, so a page never has to remember to mount
 * a button and the control is always in the same place. On a page with no
 * help entry it renders nothing — a button that opens to nothing is worse than
 * no button.
 */
export function HeaderHelpButton() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const page = helpPageForPath(pathname);
  if (page === undefined || PAGE_HELP[page] === undefined) return null;

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className="focus-ring h-8 w-8 text-ink-3 hover:text-ink"
        onClick={() => setOpen(true)}
        data-testid="page-help-open"
        aria-label={`Help for this page: ${PAGE_HELP[page].title}`}
        title="What is this page?"
      >
        <HelpCircle className="size-4" aria-hidden="true" />
      </Button>
      <HelpDialog page={page} open={open} onOpenChange={setOpen} />
    </>
  );
}
